const columnReminder = [
  {
    title: "No.",
    scopedSlots: { customRender: "stt" },
    width: 50,
    align: "center",
  },
  {
    title: "Module",
    dataIndex: "module",
    scopedSlots: { customRender: "module" },
    width: 150,
  },
  {
    title: "Days Added Default",
    dataIndex: "daysAddedDefaultInDeadline",
    scopedSlots: { customRender: "daysAddedDefaultInDeadline" },
    width: 200,
    align: "center",
  },
  {
    title: "Remind Before",
    dataIndex: "remindBefore",
    scopedSlots: { customRender: "remindBefore" },
    align: "center",
    width: 120,
  },

  {
    title: "Created at",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    width: 160,
  },
  {
    title: "Updated at",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    width: 160,
  },
  {
    title: "",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 125,
  },
];

export { columnReminder };
